import { Models } from '../../assets/ts/models';
const bpmsModel = new Models();

export default {
    data() {
        return {
            defineLoginMethod: payload.isOpenId && !payload.useIDP,
            loading: false,

            username: '',
            password: '',
            errorTxt: '',
            model: {
                username: '',
                password: '',
            }
        }
    },
    methods: {
        submit() {

            this.loading = true;

            if (!this.defineLoginMethod) {
                this.prepareLogin();
                let data = {
                    UserName: this.username,
                    Sha256Fromclient: this.model.password,
                    Sha1PasswordFromClient: this.model.username
                };

                bpmsModel.loginByOldSSo(data).done(res => {
                    window.location = res;
                }).fail((err) => {
                    this.loading = false;

                    if (err.responseText === '-1') {
                        this.errorTxt = i18n.$t('messages.password_not_currect') ;
                        return

                    } else if (err.responseText === '-2') {
                        this.errorTxt = i18n.$t('messages.connection_not_safe');
                        return
                    }
                    if (err.responseText === '-3') {
                        this.errorTxt = i18n.$t('messages.username_or_password_is_null');
                        return

                    } else {
                        this.errorTxt = i18n.$t("messages.pleas_try_later");
                        return
                    }
                });
            }
        },

        prepareLogin() {
            this.model.username = Sha1.hash(this.username.toLowerCase() + this.password);
            this.model.password = SHA256(this.password);
        }
    },
    mounted() {
        $('#login-password').on('keypress', (e) => {
            if (e.keyCode == 13)
                $('#login-submit').click();
            $('.js_loginPanel').addClass('open');
        });
    }
}
